import ShopaholicAddWishList from '@lovata/shopaholic-wish-list/shopaholic-add-wish-list';
import ShopaholicRemoveWishList from '@lovata/shopaholic-wish-list/shopaholic-remove-wish-list';

export default new class WishListAdd {
  constructor() {
    this.iconClass = '_favorite';
    this.iconSelector = 'wishlist-add__icon';
    this.sWishListInfoWrapper = 'userbar__item_wishlist';
    this.isFavoriteSelector = 'wishlist-add_favorite';

    if ($(`.${this.sWishListInfoWrapper}`).length === 0) {
      return;
    }

    this.obAddHelper = new ShopaholicAddWishList();
    this.obRemoveHelper = new ShopaholicRemoveWishList();

    this.initAddHandler();
    this.initRemoveHandler();
  }

  /* eslint-disable no-param-reassign */
  initAddHandler() {
    this.obAddHelper.setAjaxRequestCallback((obRequestData, obButton) => {
      this.turnOnFavoriteBtn(obButton);
      obRequestData.update = { 'product/wishlist/wishlist-info/wishlist-info': `.${this.sWishListInfoWrapper}` };
      obRequestData.error = () => {
        this.turnOffFavoriteBtn(obButton);
      };
      return obRequestData;
    }).init();
  }

  initRemoveHandler() {
    this.obRemoveHelper.setAjaxRequestCallback((obRequestData, obButton) => {
      this.turnOffFavoriteBtn(obButton);
      obRequestData.update = { 'product/wishlist/wishlist-info/wishlist-info': `.${this.sWishListInfoWrapper}` };
      obRequestData.error = () => {
        this.turnOnFavoriteBtn(obButton);
      };
      return obRequestData;
    }).init();
  }
  /* eslint-enable */

  turnOnFavoriteBtn(obButton) {
    obButton.removeClass(this.obAddHelper.sDefaultButtonClass);
    obButton.addClass(this.obRemoveHelper.sDefaultButtonClass);
    obButton.find(`.${this.iconSelector}`).addClass(this.iconClass);
    obButton.addClass(this.isFavoriteSelector);
  }

  turnOffFavoriteBtn(obButton) {
    obButton.removeClass(this.obRemoveHelper.sDefaultButtonClass);
    obButton.addClass(this.obAddHelper.sDefaultButtonClass);
    obButton.removeClass(this.isFavoriteSelector);
    obButton.find(`.${this.iconSelector}`).removeClass(this.iconClass);
  }
}();
